export default [
  {
    path: '/treasury/:key?',
    name: 'treasuryPage',
    component: () => import(/*webpackChunkName:'treasury'*/ '@/views/treasury/index.vue'),
    meta: {},
  },
];
